import { Skeleton } from '@/components/ui/skeleton'

const SupportSidebarSkeleton = () => {
  return (
    <nav className='flex flex-col gap-1.5 shrink-0 w-full lg:w-52 lg:border-r lg:border-border lg:pr-8'>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton key={index} className='h-9 w-full border-0 opacity-40' />
      ))}
    </nav>
  )
}

export default SupportSidebarSkeleton
